// extracted by mini-css-extract-plugin
export var buttonContent = "_4o-0";
export var buttonGroup = "_4o-1";
export var firstButton = "_4o-2";
export var lastButton = "_4o-3";